import React from 'react';
import './style.css';
import SteamIcon from '../../steam_icon.png';
import Draggable from 'react-draggable'; // Both at the same time
import { Resizable, ResizableBox } from 'react-resizable';
import SocialNetworkPT from './../../components/SocialNetworkPT';
import SocialNetworkEN from './../../components/SocialNetworkEN';
import AboutMeEN from './../../components/MeEN';
import AboutMePT from './../../components/MePT';
import LearningPT from './../../components/LearningPT';
import LearningEN from './../../components/LearningEN';

class Aba extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        open: !this.props.open,
        drag: false,
        language: 0,
        linkAtivoIndex: null,
        componentAtivo: AboutMeEN,
        linksPT: [
          {
            "title": "Aprendizagem",
            "component": LearningPT
          },
          {
            "title": "Redes Sociais",
            "component": SocialNetworkPT
          },
          {
            "title": "Sobre mim",
            "component": AboutMePT
          },
        ],
        linksEN: [
          {
            "title": "About me",
            "component": AboutMeEN
          },
          {
            "title": "Learning",
            "component": LearningEN
          },
          {
            "title": "Social Network",
            "component": SocialNetworkEN
          }  
        ]
    }
  }
  changeLanguage(){
    if(this.state.language == 0){
      this.setState({language: 1});
    } else{
      this.setState({language: 0});
    }
  }
  Close(){
    this.setState(state => ({
        open: !state.open
    }));
  }
  componentDidMount(){
    this.setState({linkAtivoIndex: 0})
  }
  controlAbas(index){
    this.setState({linksAtivoIndex: index})
    if(this.state.language == 0){
      this.setState({componentAtivo: this.state.linksEN[index].component })
    } else{
      this.setState({componentAtivo: this.state.linksEN[index].component })
    }
  }
  render(){
    return <div>
    <Draggable handle=".header">
      <div className={"abaAbout "+ (this.state.open ? 'open ' : 'closed ') + (this.state.drag ? 'drag' : '')}>
          <div className="header">
            <span className="title">
            <img src={SteamIcon}/>
            { this.props.title }
            </span>    
            <span className="close" onClick={() => { this.Close() }}> 
            <i className="fas fa-times"></i>
            </span>
          </div>
          <div className="tabs">
            { this.state.linksEN.map((item, index) => (
              <li
              data-id={this.state.linksAtivoIndex} 
              className={(this.state.linksAtivoIndex == index ? 'tabsAtivo' : '')}
              onMouseUp={() => { this.controlAbas(index) }}>
                  { item.title }
              </li>
           ))}
          </div>
          { this.state.linksAtivoIndex !== null &&
          <div className="dataT">
          { <this.state.componentAtivo/> }
          </div> }
      </div>
      </Draggable>
    </div>
  };
}

export default Aba;